export enum StressLevelEnum {
  WITH_OUT_STRESS = 'WITH_OUT_STRESS',
  ALMOST_NO_STRESS = 'ALMOST_NO_STRESS',
  LITTLE_STRESS = 'LITTLE_STRESS',
  A_LOT_OF_STRESS = 'A_LOT_OF_STRESS',
  TOO_MUCH_STRESS = 'TOO_MUCH_STRESS'
}
